import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { tinTucArticles } from '../../mocks/tin-tuc-articles';

const TinTucPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tất cả');

  const categories = [
    'Tất cả',
    'Tin giáo dục',
    'Phương pháp học',
    'Mẹo học tập',
    'Tin thi cử',
    'Phân tích đề thi',
    'Kỹ năng thi cử',
    'Xu hướng giáo dục',
  ];

  const filteredArticles =
    selectedCategory === 'Tất cả'
      ? tinTucArticles
      : tinTucArticles.filter((article) => article.category === selectedCategory);

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <Header />

        {/* Hero Section */}
        <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-teal-600 via-cyan-600 to-blue-600 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          
          <div className="relative max-w-7xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-newspaper-line text-white text-xl"></i>
              <span className="text-white font-semibold">Tin Tức Giáo Dục</span>
            </div>

            <h1
              className="text-6xl font-bold text-white mb-6"
              style={{ fontFamily: 'Merriweather, serif' }}
            >
              📰 Tin Tức & Cập Nhật
            </h1>

            <p className="text-xl text-white/95 max-w-3xl mx-auto leading-relaxed mb-8">
              <strong>Cập nhật tin tức giáo dục mới nhất</strong>, phương pháp học tập hiệu quả, 
              mẹo ghi nhớ, phân tích đề thi và xu hướng giáo dục. Luôn đồng hành cùng học sinh 
              trên con đường chinh phục tri thức.
            </p>

            <div className="flex items-center justify-center gap-6 text-white/90">
              <div className="flex items-center gap-2">
                <i className="ri-article-line text-2xl"></i>
                <span className="font-semibold">{tinTucArticles.length}+ bài viết</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-folder-line text-2xl"></i>
                <span className="font-semibold">{categories.length - 1} danh mục</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-2xl"></i>
                <span className="font-semibold">Cập nhật hàng ngày</span>
              </div>
            </div>
          </div>
        </section>

        {/* Category Filter */}
        <section className="py-8 px-6 bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-4 overflow-x-auto pb-2">
              <span className="text-gray-700 font-semibold whitespace-nowrap">Danh mục:</span>
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 rounded-full whitespace-nowrap transition-all cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-gradient-to-r from-teal-600 to-cyan-600 text-white shadow-lg'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="py-16 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredArticles.map((article) => (
                <Link
                  key={article.id}
                  to={article.id === 1 ? "/tin-tuc/phuong-phap-hoc-tap-hieu-qua" : "/tin-tuc"}
                  className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all cursor-pointer group block"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 bg-gradient-to-r from-teal-600 to-cyan-600 text-white text-xs font-semibold rounded-full">
                        {article.category}
                      </span>
                    </div>
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>

                    <p className="text-gray-600 text-sm mb-4 line-clamp-3 leading-relaxed">
                      {article.excerpt}
                    </p>

                    <div className="flex items-center justify-between text-sm text-gray-500 pt-4 border-t border-gray-100">
                      <div className="flex items-center gap-4">
                        <span className="flex items-center gap-1">
                          <i className="ri-calendar-line"></i>
                          {article.date}
                        </span>
                        <span className="flex items-center gap-1">
                          <i className="ri-time-line"></i>
                          {article.readTime} phút
                        </span>
                      </div>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {filteredArticles.length === 0 && (
              <div className="text-center py-16">
                <i className="ri-file-search-line text-6xl text-gray-300 mb-4"></i>
                <p className="text-gray-500 text-lg">Không tìm thấy bài viết nào trong danh mục này.</p>
              </div>
            )}
          </div>
        </section>

        {/* Newsletter Subscription */}
        <section className="py-16 px-6 bg-gradient-to-br from-teal-600 via-cyan-600 to-blue-600">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6">
              <i className="ri-mail-line text-3xl text-white"></i>
            </div>

            <h2 className="text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Merriweather, serif' }}>
              Đăng Ký Nhận Tin Tức Mới
            </h2>

            <p className="text-white/90 text-lg mb-8">
              Nhận ngay các tin tức giáo dục, phương pháp học tập và mẹo thi cử mới nhất 
              qua email của bạn mỗi tuần.
            </p>

            <div className="flex items-center gap-4 max-w-xl mx-auto">
              <input
                type="email"
                placeholder="Nhập email của bạn..."
                className="flex-1 px-6 py-4 rounded-full text-gray-900 outline-none focus:ring-4 focus:ring-white/30 transition-all"
              />
              <button className="px-8 py-4 bg-white text-teal-600 font-semibold rounded-full hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Đăng ký
              </button>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default TinTucPage;
